import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { AgentViewModel } from '../../../shared/models/AgentModels';
import { AgentService } from '../../../shared/services/agent.service';
import { UserService } from '../../../shared/services/user.service';

import { MaterialModule } from '../../../material/material.module';


@Component({
    selector: 'app-agent-card',
    imports: [MaterialModule],
    templateUrl: './agent-card.component.html',
    styleUrls: ['./agent-card.component.css']
})
export class AgentCardComponent implements OnInit {

  @Input() Agent: AgentViewModel;
  @Input() ConnectedPlayerId: string;
  @Output() AgentRemovedFromPlayer = new EventEmitter();
  isAllowedToEdit: boolean = false;

  constructor(private agentService: AgentService,public userService: UserService) {
    this.isAllowedToEdit = this.userService.roleMatch(["Org_Admin", "Contacts_Editor"]);
  }

  ngOnInit(): void {
    
  }

  removeFromPlayer(){
    //console.log("deleteing");
    //console.log("this.Agent.Agent.AgentId");
    this.agentService.removeAgentFromPlayer(this.Agent?.Agent?.AgentId??"", this.ConnectedPlayerId).subscribe(result=>{
      //console.log("deleted");
      if(result)
        this.AgentRemovedFromPlayer.emit();
    });

  }


}
